import MenuListItemBlock, { MenuListItemBlockProps } from './MenuListItemBlock';

export type { MenuListItemBlockProps };
export default MenuListItemBlock;
